module.exports = __webpack_public_path__ + "img/banner.88929114.png";